export function dynamicPHPPath(apiHost) {
  const API_URL_MAP = {
    'api.playposit.com': 'www.playposit.com',
    'app.playpos.it': 'www.playposit.com',
    'ebs-stage.playposit.com': 'staging.playposit.com',
    'apistage.playpos.it': 'staging.playpos.it',
    'apiankit.know.dog': 'verma.know.dog',
    'apiwill.playpauseit.com': 'wwwwill.playpauseit.com',
    'apiclayton.playpauseit.com': 'wwwclayton.playpauseit.com',
    'apimatt.playpauseit.com': 'wwwmatt.playpauseit.com',
    'localhost:8081': 'wwwmatt.playpauseit.com',
    'localhost': 'educanonllx.com',
    'apiluc.playpauseit.com': 'wwwluc.playpauseit.com',
    'msluc.playpauseit.com': 'wwwluc.playpauseit.com',
    'apichristie.playpauseit.com': 'wwwchristie.playpauseit.com',
    'apioleg.playpauseit.com': 'wwwoleg.playpauseit.com',
    'api-stage.playposit.com': 'www-stage.playposit.com',
    'api-dev.playposit.com': 'www-dev.playposit.com',
    'api-test.playposit.com': 'www-test.playposit.com',
    'mschristie.playpauseit.com': 'wwwchristie.playpauseit.com',
  };
  return `https://${(apiHost && API_URL_MAP[apiHost]) || 'www.playposit.com' }`;
}
